import { FC } from "react";
import { useIntl } from "react-intl";

interface PromptTipProps {
  labelKey: string;
  dontKey: string;
  doKey: string;
  onClick?: (doText: string) => void;
}

export const PromptTip: FC<PromptTipProps> = ({
  labelKey,
  dontKey,
  doKey,
  onClick,
}) => {
  const { formatMessage } = useIntl();

  const label = formatMessage({ id: labelKey });
  const dontText = formatMessage({ id: dontKey });
  const doText = formatMessage({ id: doKey });

  const handleClick = () => {
    if (onClick) {
      onClick(doText);
    }
  };

  return (
    <div
      className="border border-dashed border-border rounded-lg pl-3 pr-3 py-2.5 text-xs relative cursor-pointer hover:bg-background transition-colors"
      onClick={handleClick}
    >
      <span className="absolute -top-2 left-3 bg-muted px-1 text-muted-foreground text-[10px] tracking-wide font-medium">
        {label}
      </span>
      <div className="mt-1 space-y-1">
        <p className="text-muted-foreground flex items-center gap-2">
          <span className="w-4 h-4 rounded-full bg-muted text-muted-foreground flex items-center justify-center text-[10px] shrink-0">
            &#x2715;
          </span>
          {dontText}
        </p>
        <p className="text-foreground flex items-center gap-2">
          <span className="w-4 h-4 rounded-full bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 flex items-center justify-center text-[10px] shrink-0">
            &#x2713;
          </span>
          {doText}
        </p>
      </div>
    </div>
  );
};
